import { lazy } from "react";

export const lazyRetry = (componentImport) => {
  return lazy(() =>
    componentImport().catch((error) => {
      const isChunkLoadError =
        error.name === "ChunkLoadError" ||
        error.message.includes("Loading chunk");
      if (isChunkLoadError) {
        window.location.reload();
        return new Promise(() => {});
      }
      console.error(error);
      throw error;
    }),
  );
};
